import $ from 'jquery';

export default class EmailSubscription {
  constructor() {
    this.setEventListener();
  }

  setEventListener() {
    document.addEventListener( 'wpcf7mailsent', function(event) {
      console.log(event.detail);
      if ( '725' === event.detail.contactFormId ) {
        $.fancybox.open({
          src: '#success-email-subscription',
          closeExisting: true,
          smallBtn: false,
          toolbar: false,
          touch: false,
        });
      }
    }, false );
  }
}
